import Header from "@/components/Header";
import Hero from "@/components/Hero";
import HowItWorks from "@/components/HowItWorks";
import Categories from "@/components/Categories";
import FeaturedItems from "@/components/FeaturedItems";
import TrustSection from "@/components/TrustSection";
import CTASection from "@/components/CTASection";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import { SEO } from "@/components/SEO";

const Index = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="Rentify — Rent Anything from People Nearby"
        description="Rent tools, cameras, camping gear, and more from people in your neighborhood — or earn money listing what you own."
        path="/"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Rentify",
            url: "https://therentify.com",
            logo: "https://therentify.com/favicon.ico",
          },
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "Rentify",
            url: "https://therentify.com",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://therentify.com/browse?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          },
        ]}
      />
      <Header />
      
      <main className="flex-1 relative">
        <Hero />
        <FeaturedItems />
        <HowItWorks />
        <TrustSection />
        <Categories />
        <CTASection />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
};

export default Index;